import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a4dabc6")

_pushScopeId("data-v-2a4dabc6")
const _hoisted_1 = { class: "box-application flex justify-between items-baseline mb-4" }
const _hoisted_2 = { class: "box-box-application__tab flex flex-wrap pb-0" }
const _hoisted_3 = { class: "flex mb-0 list-none flex-wrap flex-row border-time-card" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("ul", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataTabs, (item, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            class: ["text-center cursor-pointer px-4 py-2 rounded block font-size-18 text-grey-999", _ctx.currentRouter.path.includes(item.path) ? 'active' : ''],
            key: index,
            to: item?.path
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(item.text), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      ])
    ])
  ]))
})